module.exports = __webpack_public_path__ + "img/customer7.af315327.jpg";